<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app right clipped>
      <v-list>
        <v-list-item link :to="{ path: '/' }">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('home') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: '/contact' }">
          <v-list-item-action>
            <v-icon>mdi-contact-mail</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('contact') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: '/support' }">
          <v-list-item-action>
            <v-icon>mdi-monitor-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('support') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app clipped-right>
      <v-img :src="require('@/assets/nwitrgb.svg')" height="50" contain position="left" />
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
    </v-app-bar>
    <v-content>
      <router-view />
    </v-content>
    <v-footer app class="overline">
      <v-col cols="8" class="hidden-sm-and-down">
        Network IT ApS &bull; Hostrupsvej 2, 1. tv. &bull; DK 1950 Frederiksberg C &bull; CVR 25384490
      </v-col>
      <v-col cols="8" class="hidden-md-and-up">
        Network IT ApS<br>
        Hostrupsvej 2, 1. tv.<br>
        DK 1950 Frederiksberg C
      </v-col>
      <v-col cols="4" class="text-right">
        &copy; {{ new Date().getFullYear() }}
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
  // import router from "./router";
  // import HomePage from "./components/HomePage";


export default {
  name: 'App',
  data: () => ({
    drawer: false,
    locale: 'da'
    //
  }),
};
</script>
